import DepositFeesInput from "../DepositFeesInput/DepositFeesInput";
import AccumulationFeesInput from "../AccumulationFeesInput/AccumulationFeesInput";
import { ContextKeys } from "../../../types/context-key";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import Classes from "./ManagementFeesInputs.module.scss";

const ManagementFeesInputs = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className={Classes.feesInputsWrapper}>
      <div className={Classes.feesInput}>
      <div className={Classes.tooltipContainer}>
        <div
          className={Classes.infoIcon}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <FontAwesomeIcon icon={faInfoCircle} />
          {showTooltip && (
            <div className={Classes.tooltip}>
              דמי ניהול אלה נגבים רק במוצרים פנסיוניים
            </div>
          )}
        </div>
      </div>
        <DepositFeesInput contextKey={ContextKeys.DEPOSIT_FEES_PERCENTAGE} />
      </div>
      <div className={Classes.feesInput}>
        <AccumulationFeesInput contextKey={ContextKeys.ACCUMULATION_FEES_PERCENTAGE} />
      </div>
    </div>
  );
};

export default ManagementFeesInputs;
